<template>
  
  <section class="section section-lg">
        <div class="container">
            <div class="row row-grid justify-content-center">
                <div class="col-lg-8 text-center">
                    <h2 class="display-3">
                      聯絡我們
                    </h2>
                    <p class="lead">
                      FLAT/RM 03, BLK A, 9/F NEW MANDARIN PLAZA NO.14 SCIENCE MUSUM ROAD TSIM SHA TSUI EAST KL <br />( 九龍尖沙咀東部科學館道14號新文華中心A 座 9樓 03室 )</p>
                    <div class="btn-wrapper mb-3">
                        <a href="mailto:admin@orchardgroup.com.hk" target="_blank" class="btn btn-success mb-3 mb-sm-0">電話: 3181 - 2396</a>
                    </div>
                    <div class="btn-wrapper">
                        <a href="mailto:admin@orchardgroup.com.hk" target="_blank" class="btn btn-primary mb-3 mb-sm-0"><span class="d-none d-md-block">或 電郵給我們</span> admin@orchardgroup.com.hk</a>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
export default {

}
</script>

<style>

</style>